import {
  ApiEndpoint,
  NotificationType,
  NotiFirebaseConfig,
  UseCase,
  UserType,
} from '@ssc-fe-common/noti-types';
import { getInjectedHeaders } from './portal';

/**
 * WMS Portal 消息中心 API 配置
 * @link https://t.ly/sD2Tm
 */
export const apiConfig: NotiFirebaseConfig['apiConfig'] = {
  isSPXCross: true,
  paths: {
    getListPath: (): string | ApiEndpoint =>
      '/api/basicserver/notification/ssc/user/message/search',
    getUnreadCountPath: (): string | ApiEndpoint =>
      '/api/basicserver/notification/ssc/user/message/unread/count',
    getMessageDetailPath: (): string | ApiEndpoint =>
      '/api/basicserver/notification/ssc/user/message/detail',
    getReadMessagePath: (): string | ApiEndpoint =>
      '/api/basicserver/notification/ssc/user/message/read',
    getReadAllMessagesPath: (): string | ApiEndpoint =>
      '/api/basicserver/notification/ssc/user/message/read/all',
    getUpdateTokenPath: (): string | ApiEndpoint =>
      '/api/basicserver/notification/ssc/user/token/update',
  },
  headers: getInjectedHeaders(),
  // 参数说明: https://apidoc.i.ssc.shopeemobile.com/project/3993/interface/api/373767
  // use_case 通知应用场景 “wms portal” "wms app"
  // user_type 通知用户类型  9: WMS Portal  12: WMS App
  // notification_type_list 通知类型 51: wms portal
  basicParams: {
    use_case: 'wms portal' as UseCase,
    user_type: 9 as UserType,
    notification_type_list: [51] as NotificationType[],
  },
};
